import {
    FormHelperText,
    Typography,
    Box,
    LinearProgress,
    Grid,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import './styles.scss';
import { UploadIcon } from '../../../assets/svg';
import { Spinner } from '../';
import { getFileExtension, getFilename } from '../../../utils/helper';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import { LightBoxImage } from '../index';
import { isVideoURL } from '../../../utils/helper';
import { getPresignedUrl } from '../../../store/actions/settingsActionCreator';
import axios from 'axios';
import { useDispatch } from 'react-redux';

const MAX_FILE_SIZE = 25600; // 5MB

// const IMAGE_FILES = ['.jpg', '.png', '.jpeg', '.bmp'];
const NON_IMAGE_FILES = ['.xlsx', '.csv', '.pdf', '.html'];
function LinearProgressWithLabel(props) {
    return (
        <Box display="flex" alignItems="center">
            <Box width="100%" mr={1}>
                <LinearProgress variant="determinate" {...props} />
            </Box>
            <Box minWidth={35}>
                <Typography
                    variant="body2"
                    color="textSecondary"
                >{`${Math.round(props.value)}%`}</Typography>
            </Box>
        </Box>
    );
}

export const uploadImageOnS3 = (file, dispatch, onSuccess, onProgress, flowType) => {
    dispatch(
        getPresignedUrl(
            {
                fileName: getFilename(file.name),
                fileType: getFileExtension(file.name),
                contentType: file.type,
                ...(flowType ? { flowType } : {}),
            },
            async (response) => {
                const presignedUrl = response?.response?.presignedUrl;
                const getPreSignedUrl = response?.response?.getPreSignedUrl;
                if (!presignedUrl) {
                    return;
                }
                try {
                    await axios.put(presignedUrl, file, {
                        headers: {
                            'Content-Type': file.type,
                        },
                        onUploadProgress: (e) => {
                            if (!e?.total) return;
                            const percent = Math.round(
                                (e.loaded * 100) / e.total,
                            );
                            onProgress?.(percent);
                        },
                    });

                    onSuccess?.(flowType ? getPreSignedUrl : presignedUrl.split('?')[0]);
                } catch (err) {
                    console.error('Upload failed', err);
                    return;
                }
            },
        ),
    );
};

export function MultiFileUploader({
    render,
    label,
    labelStyles,
    placeholder,
    onFileUploaded,
    defaultValue,
    helperText,
    disabled,
    error,
    onRemoved,
    lightboxConfig = {},
    isRequired,
    flowType = '',
    ...props
}) {
    // const classes = useStyles();
    const [uploadedFiles, setUploadedFiles] = useState(
        !!defaultValue ? defaultValue : [],
    );
    const [loading, toggleLoading] = useState(false);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        setUploadedFiles(!!defaultValue ? defaultValue : []);
    }, [defaultValue]);

    const dispatch = useDispatch();

    const uploadfile = async (e) => {
        if (e.target.files.length > 0) {
            const selectedFile = e.target.files[0];
            console.log(selectedFile.name);
            const fileSizeKiloBytes = selectedFile.size / 1024;
            console.log(fileSizeKiloBytes);
            if (fileSizeKiloBytes > MAX_FILE_SIZE) {
                alert(
                    `Maximum allowed size for a file is 25Mb.Upload less than 25Mb`,
                );
                return;
            }
            await toggleLoading(true);
            uploadImageOnS3(
                selectedFile,
                dispatch,
                (file) => {
                    onFileUploaded([...uploadedFiles, ...[file]]);
                    toggleLoading(false);
                    setProgress(100);
                },
                (value) => {
                    setProgress(value);
                },
                flowType,
            );
        }
    };

    const removeImage = (indexToRemove) => {
        const newArray = [...uploadedFiles];
        if (indexToRemove >= 0 && indexToRemove < newArray?.length) {
            newArray?.splice(indexToRemove, 1);
        }
        setUploadedFiles(newArray);
        setProgress(null);
        onRemoved && onRemoved(newArray);
    };

    function getFileNameFromS3(file) {
        return file?.split('/')[file?.split('/')?.length - 1] ?? '';
    }

    return (
        <>
            {!!label && (
                <Typography
                    variant="body1"
                    style={
                        labelStyles
                            ? {
                                  fontSize: '14px',
                                  fontWeight: 'normal',
                                  marginTop: 10,
                                  marginBottom: 0,
                                  padding: 0,
                                  color: Boolean(error) ? '#F44336' : '#14112D',
                                  ...labelStyles,
                              }
                            : {
                                  fontSize: '14px',
                                  fontWeight: 'normal',
                                  marginTop: 10,
                                  marginBottom: 0,
                                  padding: 0,
                                  color: Boolean(error) ? '#F44336' : '#515f6d',
                              }
                    }
                >
                    {label}
                    {isRequired && <span style={{ color: 'red' }}>*</span>}
                </Typography>
            )}
            <Spinner loading={loading}>
                <div className="file-upload">
                    {!!uploadedFiles?.length ? (
                        <Grid container spacing={1}>
                            {uploadedFiles?.map((imageUrl, i) => {
                                return (
                                    <Grid item sm={6} xs={6}>
                                        <div
                                            className={`image-upload-wrap ${
                                                Boolean(error)
                                                    ? 'img-border-error'
                                                    : ''
                                            }`}
                                        >
                                            {!disabled && (
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        backgroundColor: 'red',
                                                        borderRadius: '50%',
                                                        position: 'absolute',
                                                        top: -10,
                                                        right: -10,
                                                        zIndex: 99,
                                                        color: '#fff',
                                                        width: 25,
                                                        height: 25,
                                                        alignItems: 'center',
                                                        justifyContent:
                                                            'center',
                                                        cursor: 'pointer',
                                                    }}
                                                    onClick={(e) =>
                                                        removeImage(i)
                                                    }
                                                >
                                                    {'X'}
                                                </div>
                                            )}
                                            {/* <div className="drag-text"> */}
                                            {!!imageUrl &&
                                            !NON_IMAGE_FILES.find((file) =>
                                                imageUrl
                                                    ?.toLowerCase()
                                                    .includes(file),
                                            ) ? (
                                                <div className="drag-text image-drag">
                                                    <LightBoxImage
                                                        {...lightboxConfig}
                                                        source={imageUrl}
                                                        type={
                                                            isVideoURL(imageUrl)
                                                                ? 'video'
                                                                : 'image'
                                                        }
                                                    />
                                                </div>
                                            ) : (
                                                <div className="drag-text">
                                                    <AttachFileIcon />
                                                    {
                                                        <Box
                                                            style={{
                                                                display: 'flex',
                                                                flexDirection:
                                                                    'row',
                                                                justifyContent:
                                                                    'center',
                                                                alignItems:
                                                                    'flex-end',
                                                            }}
                                                        >
                                                            {/* <AttachFileIcon /> */}
                                                            <Typography
                                                                // variant="body1"
                                                                style={{
                                                                    color: 'red',
                                                                    marginLeft:
                                                                        '2px',
                                                                    width: '100%',
                                                                    wordWrap:
                                                                        'break-word',
                                                                }}
                                                            >
                                                                {/* {`${uploadedFiles}`} */}
                                                                {`${getFileNameFromS3()}`}
                                                            </Typography>
                                                        </Box>
                                                    }
                                                </div>
                                            )}
                                            {/* </div> */}
                                        </div>
                                    </Grid>
                                );
                            })}
                            {!disabled && (
                                <Grid item sm={12}>
                                    <div
                                        className={`image-upload-wrap ${
                                            Boolean(error)
                                                ? 'img-border-error'
                                                : ''
                                        }`}
                                    >
                                        <input
                                            className="file-upload-input"
                                            type="file"
                                            onChange={uploadfile}
                                        />
                                        <div className="drag-text">
                                            <UploadIcon />
                                            {progress > 0 && progress < 100 && (
                                                <LinearProgressWithLabel
                                                    value={progress}
                                                />
                                            )}
                                            <Typography variant="body1">
                                                {'Upload'}
                                            </Typography>
                                        </div>
                                    </div>
                                </Grid>
                            )}
                        </Grid>
                    ) : !render ? (
                        <div
                            className={`image-upload-wrap ${
                                Boolean(error) ? 'img-border-error' : ''
                            }`}
                        >
                            <input
                                className="file-upload-input"
                                type="file"
                                onChange={uploadfile}
                            />
                            <div className="drag-text">
                                <UploadIcon />
                                {progress > 0 && progress < 100 && (
                                    <LinearProgressWithLabel value={progress} />
                                )}
                                {!!placeholder && (
                                    <Typography variant="body1">
                                        {placeholder}
                                    </Typography>
                                )}
                            </div>
                        </div>
                    ) : (
                        <div
                            className={` ${
                                Boolean(error) ? 'img-border-error' : ''
                            }`}
                        >
                            <input
                                className="file-upload-input"
                                type="file"
                                onChange={uploadfile}
                            />
                            {render()}
                        </div>
                    )}
                </div>
                {Boolean(error) && (
                    <FormHelperText className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error">
                        {helperText}
                    </FormHelperText>
                )}
            </Spinner>
        </>
    );
}
